import { ApiConfig } from './../ApiConfig';

export const Service = {

    getFeature: async (key: string) => {
        return await fetch(`/api/features/get/${key}?token=${ApiConfig.apiKey}`);
    }
}